<template>
    <div ref="chartRef" :style="{ height, width }"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'LineChart',
    props: {
        width: { type: String, default: '100%' },
        height: { type: String, default: '400px' },
        chartData: { type: Array, required: true },
        xAxisData: { type: Array, required: true }
    },
    data: () => ({ chart: null }),
    watch: {
        chartData: { handler() { this.setOptions() }, deep: true }
    },
    mounted() {
        this.chart = echarts.init(this.$refs.chartRef);
        this.setOptions();
        window.addEventListener('resize', this.chart.resize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.chart.resize);
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    methods: {
        setOptions() {
            this.chart.setOption({
                tooltip: { trigger: 'axis', formatter: '{b}<br/>● 會話量: {c}' },
                grid: { left: '4%', right: '4%', bottom: '5%', containLabel: true },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.xAxisData,
                    axisLine: { lineStyle: { color: '#eee' } },
                    axisLabel: { color: '#999' }
                },
                yAxis: {
                    type: 'value',
                    min: 0,
                    axisLabel: { show: false }, // 隐藏左侧数值 (0-1)
                    axisTick: { show: false },  // 隐藏左侧刻度线
                    axisLine: { show: false },  // 隐藏左侧轴线
                    splitLine: { show: false }  // 隐藏网格线
                },
                series: [{
                    type: 'line',
                    data: this.chartData,
                    symbol: 'circle',
                    symbolSize: 6,
                    itemStyle: { color: '#409EFF' },
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            { offset: 0, color: 'rgba(64,158,255,0.8)' },
                            { offset: 1, color: 'rgba(64,158,255,0)' }
                        ])
                    }
                }]
            });
        }
    }
};
</script>